// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1VBl-","content":"LoadingAlert_content__1F9Pt"};